var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXSocialMediaRoundIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-social-media-round-icon 1",
    clipPath: "url(#clip0_1758_8718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9363 7.38477H16.502L13.0814 11.2945L17.1056 16.6145H13.9546L11.4867 13.3879L8.66289 16.6145H7.09619L10.7549 12.4327L6.89453 7.38477H10.1253L12.3561 10.334L14.9363 7.38477ZM14.3867 15.6773H15.2544L9.65397 8.27277H8.72303L14.3867 15.6773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1758_8718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSocialMediaRoundIcon1);
export default __webpack_public_path__ + "static/media/x-social-media-round-icon 1.1f9f8e642d57a2bc2c4792b80a026a10.svg";
export { ForwardRef as ReactComponent };